import React from 'react';
import { useCart } from '../contexts/CartContext';
import { ShoppingCart, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

const ProductCard = ({ product }) => {
  const { addItem } = useCart();

  const discountedPrice = product.discount_percent
    ? product.price * (1 - product.discount_percent / 100)
    : null;

  const handleAddToCart = () => {
    if (product.requires_prescription) {
      toast.warning('Este producto requiere receta médica');
      return;
    }
    addItem(product, 1);
    toast.success(`${product.name} agregado al carrito`);
  };

  return (
    <div className="card-product group" data-testid={`product-card-${product.id}`}>
      {/* Discount Badge */}
      {product.discount_percent && (
        <div className="absolute top-3 left-3 badge-sale z-10">
          -{product.discount_percent}%
        </div>
      )}

      {/* Prescription Badge */}
      {product.requires_prescription && (
        <div className="absolute top-3 right-3 z-10">
          <div className="bg-amber-100 text-amber-700 px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1">
            <AlertCircle className="w-3 h-3" />
            Receta
          </div>
        </div>
      )}

      {/* Image */}
      <div className="aspect-square rounded-xl bg-slate-50 mb-4 overflow-hidden">
        <img
          src={product.image_url || 'https://via.placeholder.com/300'}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Category */}
      <span className="badge-category">{product.category}</span>

      {/* Name */}
      <h3 className="font-semibold text-slate-900 mt-2 line-clamp-2 min-h-[48px]">
        {product.name}
      </h3>

      {/* Description */}
      <p className="text-sm text-slate-500 mt-1 line-clamp-2">
        {product.description}
      </p>

      {/* Price */}
      <div className="mt-3 flex items-center gap-2">
        {discountedPrice ? (
          <>
            <span className="text-xl font-bold text-[#E52225]">
              ${discountedPrice.toFixed(2)}
            </span>
            <span className="text-sm text-slate-400 line-through">
              ${product.price.toFixed(2)}
            </span>
          </>
        ) : (
          <span className="text-xl font-bold text-slate-900">
            ${product.price.toFixed(2)}
          </span>
        )}
      </div>

      {/* Stock */}
      <p className={`text-xs mt-1 ${product.stock > 0 ? 'text-green-600' : 'text-red-600'}`}>
        {product.stock > 0 ? `${product.stock} disponibles` : 'Agotado'}
      </p>

      {/* Add to Cart Button */}
      <Button
        onClick={handleAddToCart}
        disabled={product.stock === 0}
        className="w-full mt-4 btn-primary h-10"
        data-testid={`add-to-cart-${product.id}`}
      >
        <ShoppingCart className="w-4 h-4 mr-2" />
        Agregar
      </Button>
    </div>
  );
};

export default ProductCard;
